import { render, staticRenderFns } from "./AnnualLeaveRequests.vue?vue&type=template&id=5f78d1dd&"
import script from "./AnnualLeaveRequests.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports